export default "__VITE_ASSET__ClTw_Hjx__"